package pwgs.ui.scenes.allowedversionsscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.ds.components.*
import visage.ds.components.page.Page
import visage.ds.utils.EHAlign

class MAllowedVersionsScene(props: AllowedVersionsSceneProps) : AScene<AllowedVersionsSceneProps, AllowedVersionsSceneModel, AllowedVersionsSceneState, AllowedVersionsControllerFe>(props) {

    override fun createController() : AllowedVersionsControllerFe {
        return AllowedVersionsControllerFe(props, this)
    }

    override fun initState() : AllowedVersionsSceneState {
        return AllowedVersionsSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MAllowedVersionsScene.model
        Page {
            head("Allowed Versions")

            body {
                Card {
                    isLoading = m.isLoading
                    header("Allowed Versions") {
                        ResponsiveButtonWithIcon("add", "Add version", EButtonColor.Success, this@MAllowedVersionsScene.controller::onAddVersionButtonClicked)
                    }
                    infoText = "Here you can define which versions of your game are allowed to run. Perfect if you want to prevent older versions to run."
                    body {
                        Table {
                            columns {
                                fixedColumn("Versions")
                                fixedColumn("", hAlign = EHAlign.Right)
                            }
                            body {
                                m.versions.forEach { ver ->
                                    row {
                                        cell(ver)
                                        cell {
                                            IconButton("delete") {
                                                size = EButtonSize.Small
                                                color = EButtonColor.Danger
                                                variant = EButtonVariant.Link
                                                onClick = {this@MAllowedVersionsScene.controller.onDeleteVersionButtonClicked(ver)}
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (m.addDialogModel != null) {
                    val dlg = m.addDialogModel!!
                    Modal("Add allowed version") {
                        isLoading = dlg.isLoading
                        error = dlg.error
                        infoText = "Enter the new version which you want to allow to run"
                        TextField("Version", dlg.versionFieldModel)

                        footer {
                            Button("Cancel", EButtonColor.Secondary, EButtonVariant.Link, this@MAllowedVersionsScene.controller::onCancelAddVersionButtonClicked)
                            Button("Submit", EButtonColor.Primary, EButtonVariant.Filled, this@MAllowedVersionsScene.controller::onSubmitAddVersionButtonClicked)
                        }
                    }
                }
            }
        }
    }
}

class AllowedVersionsSceneState {

}

fun Components.AllowedVersionsScene(props: AllowedVersionsSceneProps) = this.registerComponent(MAllowedVersionsScene(props), {})
